<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-back-button default-href="/"></ion-back-button>
        </ion-buttons>
        <ion-title>FAQs</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content padding>
      <br/>
      <VueFaqAccordion 
        :items="myItems"
      />
    </ion-content>
  </ion-page>
</template>

<script>
import VueFaqAccordion from 'vue-faq-accordion';

export default {
    name:'faq',
    components:{
      VueFaqAccordion,
    },
    data () {
    return {
      myItems: [
          {
            title: 'What should we do as a community?',
            value: 'Don’t panic and act from fear. Don’t spread fake news or confidential information!!\
Support the patient and persons who are in quarantine by. Respecting their privacy. Offering help – food, \
communication and kindness. BUT keep your distance - >1m, in outside air, no touching. Change the way we \
greet people. Don’t shake hands – touch elbows like West Africans did during Ebola. Educate but don’t stigmatise.\
 Encourage handwashing and make it easy. Be vigilant regarding symptoms and self-isolate if ill.',
            category: 'English'
          },
          {
            title: 'Who is at risk of getting infected?',
            value: 'The Department has recently noted a surge of frantic calls to various healthcare facilities across\
             the province, from members of the public with ordinary flu symptoms but highly suspicious that they may \
             have contracted COVID-19. We would like to assure the public that it is not everyone who is presenting \
             with flu symptoms is sick of coronavirus.\
The people who are at risk are those who have been very close to the patient (within 1m) for an extended time period, \
WHILST the patient was infectious. A person who is at risk is called a ‘contact’. Contacts include household members including \
domestic help, work colleagues, health care workers. Contacts do not include – persons who were NOT close to the patient (>1-2m); \
persons who were close to the patient when the patient did not have symptoms, members of the public, ‘contacts of contacts’.\
The Department had mobilised resources way ahead of time to prepare for the unenviable eventuality. \
This included identification of 4 designated hospitals (Greys, Addington, Ngwelezane, and Manguziwi Hospitals) \
with isolation units to admit confirmed cases and complementing them with highly skilled clinicians on treatment of infectious diseases.',
            category: 'English'
          },
          {
            title:'How is it spread?',
            value:'By breathing in droplets – when standing within 1m of a person who is infected. By direct contact \
            followed by touching of mouth, nose and eyes (auto-inoculation). According to World Health Organisation, \
            the COVID-2019 spreads mainly via respiratory droplets when an infected person coughs or sneezes. \
            Close personal contact such as touching or shaking hands. Touching an object or surface with the virus on it,\
             then touching your mouth, nose or eyes before washing your hands.\
Preliminary information suggests older adults and people with underlying health conditions such as asthma, diabetes,\
 heart disease or compromised immune systems may be at higher risk of severe illness from this virus. Many characteristics of\
  this virus and how it may affect people are still unclear.  Signs and symptoms of this illness include fever, cough, and difficulty breathing. \
  This Novel Coronavirus has the potential to cause severe disease and death.',
            category:'English'
          },
          {
            title:'How do we stop it from spreading?',
            value:'Stop ill persons from making droplets, encourage sick people to stay at home, in hospital cover persons with a mask, \
            keep a distance from people. Avoid touching mouth or nose, Wash hands frequently and/or use alcohol-based hand sanitizer, \
            Clean surfaces which people touch, Find other ways of greeting people.',
            category:'English'
          },
          {
            title:'Do masks help?',
            value:'Surgical masks are useful to trap larger invisible droplets which may contain infectious particles. N95 masks are ‘filters’\
             and remove 95% of the smallest infectious particles which are found in the air. ',
            category:'English'
          },
          {
            title:'When should we wear masks?',
            value:'The WHO says that members of the public who are well don’t benefit from wearing masks. Sick/coughing persons protect other people \
            by wearing surgical masks. N95 masks are used by health workers in special circumstances.',
            category:'English'
          },
          {
            title:'When are persons with COVID-19 infectious?',
            value:'When they develop symptoms. People are NOT infectious if they don’t have symptoms. People are NOT infectious whilst they are incubating the illness.',
            category:'English'
          },
          {
            title:'What will the health authorities do?',
            value:'All the patients who will test positively will be admitted to hospital for isolation and will be given all the care they need, in a safe way. \
            The doctor/HCW who took the specimen will identify all the ‘contacts’ of the patient. The health department will contact all the patients and ask them \
            to ‘self-quarantine’.',
            category:'English'
          },
          {
            title:'What does ‘quarantine’ mean?',
            value:'Separating a WELL person who is a contact (i.e. is at risk of infection) from others, so that if that person develops illness, s/he will not pass the infection on.',
            category:'English'
          },
          {
            title:'What does ‘isolation’ mean?',
            value:'Separating an ILL person who has the disease (or may have the disease) from others, so that if that person develops illness, s/he will not pass the infection on. ',
            category:'English'
          },
          {
            title:'How do I quarantine myself?',
            value:'Do not go to work/school. Stay at home. Keep separate from other household members. Don’t go out. Don’t use public transport. Check temperatures and symptoms daily \
            using a form on the NICD website (contact monitoring form). If illness develops, use a mask and get tested.',
            category:'English'
          },
          {
            title: 'Yini okumele yenziwe umphakathi?',
            value: 'Akumele wesabe, futhi umphakathi akumele ubhebhezele izindaba ezingolona iqiniso noma ulwazi oluyimfihlo!!!\
Kumele besekwe labo abagulayo ngenxa yalesi sifo, noma abantu abavalelwe emakhaya abo ukuze kuvikeleke ilungelo labo lemfihlo. \
Labo abazivalele (self-quarantine) abahlinzekwe ngosizo kanye nokudla, kuxhunyanwe nabo futhi kube nozwelo. Kubalulekile ukuthi kugcinwe ibanga iliyigxathu nesigamu 1.5m uma abantu bexoxa bengaphandle, sigwemw uthintana. \
Kumele sishintshe indlela esibingelela ngayo. Kungaxhawulwana, uma kuphoqa ukuthi kuthintwane abantu abasebenzise indololwane njengoba kwenzeka emazweni aseNtshonalanga ye-Africa ngesikhathi se-Ebola, kodwa uma kungenzeka bekungakuhle kungathintwana. \
Asifundisane ngalesis sifo kodwa asebegula singabacwasi.  \
Asigqugquzele ukugezwa kwezandla senze kube lula. \
Asiqaphele izimpawu bese sizigcina sodwa uma sigula.',
            category: 'IsiZulu'
          },
          {
            title: 'Ubani osengcupheni yokuthola leligciwane?',
            value: 'UMnyango wezeMpilo uthola inqwaba yezingcingo ezivela kwizakhamuzi ezinezimpawu zomkhuhlane owejwayelekile, kodwa ezisolayo ukuthi sezinalo leligciwane. Sithanda ukuqinisekisa uMphakathi ukuthi akusiyena wonke umuntu onomkhuhlane onalesisifo i-coronavirus.\
Abantu abasengcupheni yokuba nalesi sifo yilabo abake baba sebangeni elingaphansi kuka 1.5m isikhashana nabantu abanaleli gciwane. Umuntu osengcupheni yaleligciwane ubizwa ngokuthi ‘contact’. I-Contact ihlanganisa abantu abahlala ndawonye nomuntu onaleligciwane, \
abantu abangabasizi emakhaya, abalingani emsebenzini kanye nabasebenzi bezeMpilo. Noma umuntu oke waba seduze kakhulu nomuntu osegula kakhulu noma osenezimpawu zalesi sifo. I-Contacts ayihlanganisi abantu abangakaze basondelane nomuntu onaleligciwane ibanga elingaphansi kuka (1.2m);\
 abantu abasondalane nomuntu ophethwe ileli gciwane kade engakabii nezimpawu, ngoba umuntu ongakabi nezimpawu akakwazi ukudlulisa leligciwane kalula.\
UMnyango wezeMpilo usukwazile ukuhlanganisa izinsiza ezizokwelekelela uma ngabe kwenzeka i-coronavirus ibhebhetheka neNingizimu Africa yonke. Lokhu kuhlanganisa izibhedlela ezithile esifundazweni iKwaZulu-Natali okuyizona esezihlonziwe ukuthi zizofaka iziguli ezinaleli gciwane, \
lapho iziguli zizohlala ngazodwana uma sekuqinisekisiwe ukuthi zinayo i-coronavirus. Lezi zibhedlela zinabantu abaqeqeshiwe futhi abanolwazi olunzulu ngesifo i-coronavirus. ',
            category: 'IsiZulu'
          },{
            title:'Ibhebhetheka kanjani i- Coronaviru?',
            value:'Ngokuthi kuphume uketshezi kumuntu onayo, – bese luthinta ongenayo. Nokuthintana kwemilomo, inganena ngamakhala kanye namehlo. NgokweNhlangano yezeMpilo yamazwe omhlaba (World Health Organisation) I COVID-2019 ibhebhetheka kakhulu ngokuthi kube khona okusaketshezi \
            uma onayo ekhwehlela noma ethumula. Ukusondelana komuntu onayo ngokuthi nithintane noma nixhawulane. Kungaba ukuthinta into enalo igciwane bese ufika uthinta lapho maqede uthinte umlomo noma ikhala okukanye amehlo ngaphambi kokugeza izandla.\
Ngokolwazi olukhona luveza ukuthi abantu asebekhulile abanesifo i-asthma, ushukela, isifo senhliziyo, amasosha abo omzimba abuthakathaka yibona abasengcupheni yokuthi bengakuthola lokhu kugula. Njengegciwane eliselisha Kubantu osolwazi basematasatasa ukuzama ukuthola izixazululo ngalesi sifo.\
 Izimpawu zalokhu kugula zihlanganisa phakathi kwezinye imfiva, ukukwehlela kanye nokwehluleka ukuphefumula. Kanti lesi sifo uma ungasheshi kwenza imizamo yokusinqanda uma sesikuphethe, kuyenzeka sihlasele ngamandla okungaholela ngisho ekutheni umuntu agcine ngokudlula emhlabeni.',
            category:'IsiZulu'
          },
          {
            title:'Singasinqanda kanjani ukuthi sibhebhetheke? ',
            value:'Ngokuthi sigqugquzele labo abanaso ukuthi bahlale emakhaya bangayi ndawo. Balandele imiyalelo yabezeMpilo, abantu bafake izifihlabuso (Musk) bese baqhelelane ibanga elingaphezulu kuka 1.5m uma bexoxa noma uzwa kuthi khwehlela noma thimula. \
            Bagweme ukuthintana, ukuthinta umlomo kanye nekhala, namehlo. Kugezwe izandla njalo, noma kusetshenziswe insipho eyisihlanzi magciwane. Sihlanze lapho kade sithintwa khona abantu. Sibe nezinye izindlela zokubingelelana. ',
            category:'IsiZulu'
          },{
            title:'Angakube isifihlabuso siyalekelela?',
            value:'Isifihlabuso sabezempilo siyalekelela ukuvimba amagciwane angaqukethwa ileli gciwane. Isifihlabuso esibizwa nge N95 sivimba cishe u 95% wamagciwane angatholakala emoyeni.',
            category:'IsiZulu'
          },{
            title:'Yinini lapho kufanele ufake khona isifihlabuso?',
            value:'Inhlangano yezeMpilo yamazwe omhlaba (WHO) ithi izakhamuzi  ezingenayo i-coronavirus angeke kuzisize ukusebenzisa isifihlabuso, kepha izakhamuzi ezingasizakala ngokufaka izifihlabuso yilezo esezinayo i-coronavirus. Uma ugula, ukhwehlela lokho kungavikela abanye ngokuthi ufake isifihlabuso. Izifihlabuso ezisizayo ama N95 lezo esitshenziswa kakhulu abezeMpilo ezimeni ezithize. ',
            category:'IsiZulu'
          },{
            title:'Inini lapho khona umuntu aba nesifo COVID-19?',
            value:'Uma usunezimpawu zayo. Angeke umuntu atheleleke nge-coronavirus uma umuntu onayo engakabi nezimpawu. Onayo angeke akwazi ukuthelela omunye uma eselashiwe ingasabonakali emzimbeni noma engesenazo izimpawu.',
            category:'IsiZulu'
          },{
            title:'Yini ezokwenziwa iziphathimandla zezeMpilo?',
            value:'Zonke iziguli okuzotholakala ukuthi zinayo i-coronavirus zizongeniswa esibhedlela, zifakwe endaweni ngazodwana bese zinikwa usizo lwezempilo eziludingayo, ngendlela ephephile. UDokotela ozothatha izikhwehlela uzobe eselandela umlando wesiguli nabo bonke okungenzeka ukuthi basondelene naso. UMnyango wezeMpilo uzobe usuxhumana nabo bonke abasondelene nesiguli leso, bese benxuswa ukuba bahlale endlini bengaphumi.',
            category:'IsiZulu'
          },{
            title:'Kusho ukuthi ukuhlala ngawedwana ungaphumi ‘quarantine’?',
            value:'Kusho ukuthi kuzosuswa isiguli leso esinayo, ukuze uma ngabe sekunezimpawu singeke sithelele abanye.',
            category:'IsiZulu'
          },{
            title:'Kusho ukuthini ukubekwa ngawedwana  ‘isolation’ ?',
            value:'Ukususwa komuntu onaso isifo kwabanye abantu, ukuze uma eseqala izimpawu zokugula engeke akudlulisele kwabanye ukugula.',
            category:'IsiZulu'
          },{
            title:'Ukwazi kanjani ukuthi uzisuse eduze kwabanye abantu?',
            value:'Awuyi esikoleni noma emsebenzini. Uhlala ekhaya. Uyaqhela eduze kwabantu ohlala nabo endlini. Awuphumeli ngaphandle. Awusebenzisi izithuthi zomphakathi ezisetshenziswa umphakathi. Kumele uzame ukuzihlola amazing okushisa ngaso sonke isikhathi, kanye nezimpawu zinsuku zonke ngokusebenzisa imiyalelo yabakwa NICD ekwi website yabo. Uma ngabe usuqala ukugula, noma ubona izimpawu zalesi sifo sondela emtholampilo wangakini \
            noma ushayele inombolo yamahhala 0800 029 999  izibhedlela zethu zikulungele ukubhekana nalesi sifo. Kuphela kudingeka kube nokubambisana okukhulu phakathi kukahulumeni kanye nemiphakathi. Ngokubambisana sizoyinqoba i-Coronavirus. ',
            category:'IsiZulu'
          }
        ]
    }
  }
}
</script>

<style scoped>
ion-toolbar {
  --ion-toolbar-background:#fbc414;
  --ion-text-color:white;
}
ion-back-button{
    --color:white;
}
</style>